        import { errorMessage } from "./errorMessage";
        // Función para guardar los datos en sessionStorage
        function saveData() {
            const classE = document.getElementById('classE').value;
            const classS = document.getElementById('classS').value;
            const classV = document.getElementById('classV').value;
            const classSprinter = document.getElementById('classSprinter').value;

            sessionStorage.setItem('classE', classE);
            sessionStorage.setItem('classS', classS);
            sessionStorage.setItem('classV', classV);
            sessionStorage.setItem('classSprinter', classSprinter);
        }


        // Agregar evento al botón Next
        document.getElementById('nextButton').addEventListener('click', function(event) {
            event.preventDefault(); // Prevenir la navegación por defecto
            const allZeros = ((classE.value == '0') && 
            (classS.value == '0') && 
            (classV.value == '0') && 
            (classSprinter.value == '0'));
            //alert(!allZeros);
            if (!allZeros) {
                saveData(); // Guardar los datos
                window.location.href = 'dates.html'; // Redirigir a la página de fechas
            }
            else {
                const message = "You have not selected any vehicle"
                errorMessage(message);
            }
        });